import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Users, UserCheck, Clock, Building2, FileWarning, ClipboardList } from 'lucide-react';

const cards = [
  { key: 'total_employees', label: 'Total Employees', icon: Users, color: 'bg-blue-500' },
  { key: 'active_employees', label: 'Active', icon: UserCheck, color: 'bg-green-500' },
  //{ key: 'probation_employees', label: 'On Probation', icon: Clock, color: 'bg-amber-500' },
  { key: 'department_count', label: 'Departments', icon: Building2, color: 'bg-indigo-500' },
  //{ key: 'pending_approvals', label: 'Pending Approvals', icon: ClipboardList, color: 'bg-orange-500' },
  //{ key: 'expiring_documents', label: 'Expiring Documents', icon: FileWarning, color: 'bg-red-500' },
];

const EmployeeMasterKPIs = () => {
  const [kpis, setKpis] = useState(null);

  useEffect(() => {
    axios.get('/v1/employee-master/dashboard/kpis').then((r) => setKpis(r.data)).catch(() => setKpis({}));
  }, []);

  if (!kpis) return <div className="h-24 bg-gray-100 animate-pulse rounded-lg mb-6" />;

  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-3 mb-6">
      {cards.map(({ key, label, icon: Icon, color }) => (
        <div key={key} className="bg-white rounded-lg shadow p-4 flex items-center gap-3">
          <div className={`${color} p-2 rounded-lg text-white`}>
            <Icon className="w-5 h-5" />
          </div>
          <div>
            <p className="text-2xl font-bold text-gray-900">{kpis[key] ?? 0}</p>
            <p className="text-xs text-gray-500">{label}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default EmployeeMasterKPIs;
